import React from "react";
import {
  CustomAboutUsCard,
  ImageContainer,
  CardImage,
  CardTitle,
  CardDescription,
} from "./styles";

export default function AboutUsCard({ image, title, description }) {
  return (
    <CustomAboutUsCard>
      <ImageContainer>
        <CardImage src={image} />
      </ImageContainer>
      <CardTitle>{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
    </CustomAboutUsCard>
  );
}
